import {Datei} from "../../datei/datei.model";
import {DateiArt} from "../../datei/dateiart.model";

export class DateiExtenderUtils {
    public static dateiExtender (component: any, datei: Datei): void {
        if(datei != null) {

            if(datei.art == DateiArt[DateiArt.DOKUMENT]) {
                for(let g=0; g<component.dateiArtDetails.DOKUMENT.length; g++) {
                    for(let h=0; h<component.dateiArtDetails.DOKUMENT[g].mimetypes.length; h++) {
                        if(component.dateiArtDetails.DOKUMENT[g].mimetypes[h] == datei.mimetype) {
                            datei.temp_icon = component.dateiArtDetails.DOKUMENT[g].icon;
                        }
                    }
                }
            }

            if(datei.art == DateiArt[DateiArt.VIDEO]) {
                for(let g=0; g<component.dateiArtDetails.VIDEO.length; g++) {
                    for(let h=0; h<component.dateiArtDetails.VIDEO[g].mimetypes.length; h++) {
                        if(component.dateiArtDetails.VIDEO[g].mimetypes[h] == datei.mimetype) {
                            datei.temp_icon = component.dateiArtDetails.VIDEO[g].icon;
                        }
                    }
                }
            }


        }
    }


}
